import { useEffect, useState } from "react";
import { Modal, Table, message } from "antd";
import ReportService from "../../../../service/ERP/Report.service";
import { detailColumns } from "../../../../pages/ERP/reports/sales-history/model";
import useOpenDoc from "../../../../hooks/useOpenDoc";

const reportService = ReportService();
const PAGINATION = { pageSize: 15, showSizeChanger: true };

export default function ModalSalesHistoryDetail({ open, close, fg_code, cuscode, title }) {
  const { openJo } = useOpenDoc();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open || !fg_code || !cuscode) return;
    setLoading(true);
    setData([]);
    reportService
      .getSalesHistoryDetail({ fg_code, cuscode })
      .then((res) => setData(res?.data?.data || []))
      .catch(() => message.error("โหลดรายละเอียดไม่สำเร็จ"))
      .finally(() => setLoading(false));
  }, [open, fg_code, cuscode]);

  return (
    <Modal
      title={`รายละเอียด JO – ${title || ""}`}
      open={open}
      onCancel={close}
      footer={null}
      width={900}
      destroyOnHidden
    >
      <Table
        size="small"
        rowKey="detail_code"
        loading={loading}
        columns={detailColumns({ openJo })}
        dataSource={data}
        scroll={{ x: "max-content" }}
        pagination={PAGINATION}
      />
    </Modal>
  );
}
